import React from 'react'

import { Table, Modal, Button, Form } from '_zari/core'

import * as FacturacionService from 'services/facturacion.service'

const DocumentosAnticiposModal = ({ handleClose, show, values, setValues, reiniciarFormularioMontos }) => {
  const [documentos, setDocumentos] = React.useState([])

  React.useEffect(() => {
    FacturacionService.obtenerAnticiposxSocio(values._idSocio).then(({ data }) => {
      setDocumentos(
        data.map(x => {
          return {
            ...x,
            checked: values.idsAnticipos.some(y => y === x._id)
          }
        })
      )
    })
  }, [values._idSocio, values.idsAnticipos])

  const checkDocumentoChange = ({ e, _id }) => {
    setDocumentos(prev => {
      return prev.map(x => {
        return {
          ...x,
          checked: x._id === _id ? !x.checked : x.checked
        }
      })
    })
  }

  const clickSeleccionarAnticipo = () => {
    const seleccionados = documentos.filter(x => x.checked)

    const idsSalidas = []
    const infosSalidas = []
    let sumaSalida = 0

    for (let i = 0; i < seleccionados.length; i++) {
      const sel = seleccionados[i]

      idsSalidas.push(sel._id)
      infosSalidas.push(`${sel.serieDocumento} - ${sel.numeroDocumento} (${sel.fechaEmision})`)
      sumaSalida += sel.montoTotal
    }

    values.idsAnticipos = idsSalidas
    values.montoAnticipo = sumaSalida
    values.infosAnticipos = infosSalidas
    setValues(values)
    reiniciarFormularioMontos()
    handleClose()
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>Seleccionar Anticipo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table
          maxRowsShown={15}
          filas={documentos}
          headRows={[
            { label: '-', width: 70, align: 'center' },
            { label: 'FECHA', align: 'center' },
            { label: 'DOCUMENTO', align: 'center' },
            { label: 'TOTAL', align: 'center' }
          ]}
          rowTemplate={row => (
            <Table.Row hover key={row._id}>
              <Table.Cell align='center'>
                <Form.Checkbox
                  checked={row.checked}
                  onChange={e => checkDocumentoChange({ e, _id: row._id })}
                  id={`flag-${row._id}`}
                  label=''
                />
              </Table.Cell>
              <Table.Cell className='text-center'>{row.fechaEmision}</Table.Cell>
              <Table.Cell className='text-center'>{`${row.serieDocumento} - ${row.numeroDocumento}`}</Table.Cell>
              <Table.Cell className='text-center'>{row.montoTotal}</Table.Cell>
            </Table.Row>
          )}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose} color='secondary'>
          Cancelar
        </Button>
        <Button onClick={clickSeleccionarAnticipo}>Guardar</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(DocumentosAnticiposModal)
